import { Api } from '../api';
import {
  GetUserViewPreferenceRequest,
  GetUserViewPreferenceResponse,
  UpdateUserViewPreferenceRequest,
} from './model';

export const userViewPreferenceApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    updateUserViewPreference: builder.mutation<
      any,
      UpdateUserViewPreferenceRequest
    >({
      query(arg) {
        return {
          url: `/hub/orgs/api/user-preference`,
          method: 'POST',
          body: arg,
        };
      },
    }),
    getUserViewPreference: builder.query<
      GetUserViewPreferenceResponse,
      GetUserViewPreferenceRequest
    >({
      query(arg) {
        return {
          url: `/hub/orgs/api/user-preference`,
          method: 'GET',
          params: arg,
        };
      },
    }),
  }),
});

export const {
  useUpdateUserViewPreferenceMutation,
  useLazyGetUserViewPreferenceQuery,
} = userViewPreferenceApi;
